import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const ShotsOnGoalContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.shotsOnGoal};

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const HeaderContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
    display: flex;
`;
